import * as React from 'react';
import { useStyles } from './css';
import { HeaderAppBar } from '../../components/HeaderAppBar/HeaderAppBar';
import { Footer } from '../../components/Footer/Footer';

export function DeveloperPages({ children }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <HeaderAppBar />
            <main>{children}</main>
            <Footer />
        </div>
    );
}
